// Idioma y tema de la plataforma. Sin barra superior: en escritorio van en el encabezado de cada página, a la altura
// del título (comun/PaginaModulo.jsx); en móvil, en la barra con el botón del menú (Encabezado.jsx).
// CONTRATO: los botones «Cambiar a tema oscuro» / «Cambiar a tema claro» (ThemeToggle) y «Idioma: …».
import { ThemeToggle } from '../../ds/components/motion/ThemeToggle';
import { useDbTheme } from '../../ds/theme/ThemeProvider';
import { cn } from '../../ds/lib/cn';
import { useNavegacion } from './navegacion';
import SelectorIdioma from './SelectorIdioma';

export default function ControlesGlobales({ className }) {
  const { theme, setTheme } = useDbTheme();
  const { revelarTema } = useNavegacion();
  return (
    <div data-controles-globales="" className={cn('flex shrink-0 items-center gap-1', className)}>
      <SelectorIdioma />
      <ThemeToggle theme={theme} onChange={setTheme} reveal={revelarTema} size="sm" />
    </div>
  );
}
